import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { Video } from '../models';

export const videosActions = createActionGroup({
    source: 'Videos',
    events: {
        'Get Video': props<{ id: string }>(),
        'Get Video Success': props<{ payload: Video }>(),
        'Get Video Error': props<{ id: string; code: number }>(),
        'Set Loading': props<{ id: string }>(),
        Clear: emptyProps(),
    },
});
